// Allowed emails for export report feature
export const ALLOWED_EXPORT_EMAILS = [
  'thien.tran14@mservice.com.vn',
  'thao.vu3@mservice.com.vn',
  'tuan.nguyen22@mservice.com.vn',
  'dong.ngo@mservice.com.vn',
  'trang.tran6@mservice.com.vn',
  'hoang.truong3@mservice.com.vn',
]
